export const alert = text => `<p class="text-danger text-center my-2" role="alert">${text}</p>`;
